<template>
  <Pill
    :variant="PillVariant.INFO_PRIMARY"
    size="sm"
    class="cursor-pointer"
    @click.stop="
      copy({
        value: id,
        successMessage
      })
    "
  >
    {{ t('common_labels.id') }}
  </Pill>
</template>
<script setup lang="ts">
import Pill, { PillVariant } from '@component-module/components/Pill/Pill.vue';
import { useCopy } from '@shared/composables/useCopy';
import { useI18n } from 'vue-i18n';

const { copy } = useCopy();
const { t } = useI18n();
const { id, successMessage } = defineProps<{
  id: string;
  successMessage?: string;
}>();
</script>
<style scoped lang="scss">
.cursor-pointer {
  cursor: pointer;
}
</style>
